export const generateShortUid = (): string =>
    'xxxxxxx'.replace(/[xy]/g, () => {
        const r = ((Math.random() * 26) | 0) + 10;
        return r.toString(36).toUpperCase();
    });

export const generateUid = (): string => {
    if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
        return Array.from(crypto.getRandomValues(new Uint8Array(32)))
            .map(value => value.toString(16).padStart(2, '0'))
            .join('');
    }

    return generateShortUid() + generateShortUid();
};
